import * as React from 'react';
import {Formik} from 'formik';


// Basically a workaround for the Formik 1.x limitation of not being able
// to validate initialValues.
class FormikForm extends React.Component<any, any> {
  formikRef;

  constructor(props) {
    super(props);

    this.formikRef = React.createRef();
  }

  componentDidMount = () => {
    if (this.formikRef.current && this.props.validateOnInit) {
      this.formikRef.current.validateForm();
    }
  };

  componentDidUpdate = (prevProps) => {
    if (this.props.validateOnInit && this.props.initialValues !== prevProps.initialValues) {
      this.formikRef.current.validateForm();
    }
  };

  render() {
    return (
      <Formik ref={this.formikRef} {...this.props} />
    );
  }
}

export default FormikForm;
